<!--  付款单行信息 -->
<template>
  <div>
    <vxe-grid
      border
      show-overflow
      resizable
      class="vxe-table-element"
      size="mini"
      align="left"
      :auto-resize="true"
      :data="deductionInfoList"
      :columns="Column"
      show-footer
      :footer-method="footerMethod"
    >
      <vxe-table-column
        v-for="(item, index) in Column"
        :key="index"
        :fixed="item.fixed"
        :visible="item.visible"
        :width="item.width || 120"
        :sortable="item.sortable"
        :field="item.field"
        :formatter="item.formatter"
        :params="item.params"
        :type="item.type"
      >
      </vxe-table-column>
    </vxe-grid>
  </div>
</template>

<script>
  // import SiruiTable from '@/components/SiruiTable';
  // import { mapState } from 'vuex';
  export default {
    components: {
      // SiruiTable,
    },
    props: ['deductionInfoList'],
    computed: {
      // 付款申请明细
      Column() {
        return [
          {
            // 序号
            type: 'seq',
            width: 80,
            title: this.$t('paymentApplyListAdd.invoiceLine.table.payableInvoiceDetailNo'),
          },
          {
            //公司
            field: 'payableSettlementNo',
            title: '应付结算单号',
            width: 200,
          },
          {
            //本次抵扣金额
            field: 'realityDeductionAmount',
            title: '本次抵扣金额',
            width: 200,
          },
          {
            //抵扣时间
            field: 'gmtCreate',
            title: '抵扣时间',
            width: 200,
          },
          {
            //结算单操作员
            field: 'operator',
            title: '结算单操作员',
            width: 200,
          },
        ];
      },
    },

    mounted() {},
    watch: {},
    data() {
      return {};
    },

    methods: {
      footerMethod({ columns, data }) {
        return [
          columns.map((column, columnIndex) => {
            if (columnIndex === 0) {
              return this.$t('xTable.total');
            }
            if (['realityDeductionAmount'].includes(column.property)) {
              return data
                .map((i) => i['realityDeductionAmount'])
                .reduce((acc, cur) => {
                  const num = this.$cal.calCommon(acc, cur, '+', 'amount');
                  return this.$baseRequest.formatTableColumn(num);
                }, 0);
            }
          }),
        ];
      },
    },
  };
</script>
